import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

function Tooltip(props) {
  const { class_name, icon, width, height, handleClick, title,position="bottom" } = props;
  return (
    <>
      <img
        data-tooltip-id={title}
        className={class_name}
        src={icon}
        alt="...img"
        width={width}
        height={height}
        onClick={handleClick}
      />
      <ReactTooltip
        id={title}
        place={position}
        content={title}
        className="z-10"
        style={{padding:"5px", fontSize:"11px",paddingBottom:"2px",paddingTop:"2px"}}
      />
    </>
  );
}

export default Tooltip;
